import React from 'react';

const Services = () => {
  const insuranceCompanies = [
    {
      name: 'LIC Insurance Corporation of India',
      logo: '/images/lic.logo.png',
      description: 'Term Insurance Plans, Endowment Plans(Savings + Insurance),  Whole Life Plans, Pension / Retirement Plans,  Children Plans.'
    },
    {
      name: 'Star Health and Allied Insurance Co. Ltd.',
      logo: '/images/star.image.png',
      description: ' Comprehensive Health Insurance Plans,  Family Floater Plans, Disease-Specific Plans, Top-Up and Super Top-Up Plans, Unique Features, Senior Citizen Plans.'
    },
    {
      name: 'Bajaj Allianz General Insurance Co. Ltd.',
      logo: '/images/bajaj-allianz-logo.webp',
      description: 'Critical Illness Plans, Global Health Coverage, Personal Accident Plans, Motor Insurance, Home Insurance.'
    },
    {
      name: 'Tata AIG General Insurance',
      logo: '/images/tata-aig-logo.png',
      description: 'Arogya Sanjeevani Policy, Criti MediCare, MediCare Series, Senior Citizen Health Insurance.'
    },
    {
      name: 'HDFC Life Insurance',
      logo: '/images/hdfc-life-logo.png',
      description: 'Term Insurance Plans, Endowment Plans(Savings + Insurance),  Whole Life Plans, Pension / Retirement Plans,  Children Plans.'
    }
  ];

  /* Achievements data - to be added later
  const achievements = [
    {
      image: '/images/achievement1.jpg',
      title: 'Top Performer 2023',
      description: 'Recognized as the top insurance advisor in the region'
    },
    {
      image: '/images/achievement2.jpg',
      title: 'Customer Excellence',
      description: 'Awarded for outstanding customer service and satisfaction'
    },
    {
      image: '/images/achievement3.jpg',
      title: 'Best Sales Record',
      description: 'Achieved highest sales targets for three consecutive years'
    },
    {
      image: '/images/achievement4.jpg',
      title: 'Professional Excellence',
      description: 'Certified professional with advanced insurance expertise'
    },
    {
      image: '/images/achievement5.jpg',
      title: 'Community Impact',
      description: 'Recognized for making insurance accessible to all'
    }
  ];
  */

  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-blue-100 py-20" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            Our Insurance Partners
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            We work with leading insurance companies to provide you with the best coverage options tailored to your needs.
          </p>
        </div>

        <div className="mt-16 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {insuranceCompanies.map((company) => (
            <div
              key={company.name}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="p-8">
                <div className="h-32 w-32 flex items-center justify-center bg-blue-50 rounded-lg mb-6 overflow-hidden mx-auto">
                  {company.logo ? (
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <span className="text-2xl font-bold text-blue-600">
                      {company.name.split(' ')[0]}
                    </span>
                  )}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {company.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {company.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Achievements Section - Commented out for later use
        <div className="mt-24">
          <div className="text-center">
            <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
              Our Achievements
            </h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Recognitions and milestones that showcase our commitment to excellence
            </p>
          </div>

          <div className="mt-16 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={achievement.image}
                    alt={achievement.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {achievement.title}
                  </h3>
                  <p className="text-gray-600">
                    {achievement.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default Services; 